import * as React from "react";
import { formatRut } from "../../helperComponents/InputRut/rutValidate";
import { FaPen } from "react-icons/fa";
import { colorStatus } from "./helper/polizaRenewalHelper";
import "./polizaRenewal.scss";
import * as moment from "moment";

var ListPolizaRenewal = function ListPolizaRenewal(props) {
  var polizaRenewals = props.polizaRenewals,
      onSelectedPolizaRenewal = props.onSelectedPolizaRenewal;
  /* poliza.status PUEDEN SER => "BORRADOR" , "VIGENTE", "NO VIGENTE"
  poliza.sub_status PUEDEN SER => "NUEVA", "POR RENOVAR" ..... */

  var listPolizaRenewals = function listPolizaRenewals() {
    return polizaRenewals.map(function (polizaRenewal) {
      var _polizaRenewal$poliza, _polizaRenewal$poliza2, _polizaRenewal$poliza3, _polizaRenewal$poliza4, _polizaRenewal$poliza5, _polizaRenewal$poliza6, _polizaRenewal$poliza7, _polizaRenewal$poliza8;

      return /*#__PURE__*/React.createElement("tr", {
        key: polizaRenewal.id
      }, /*#__PURE__*/React.createElement("th", {
        scope: "row"
      }, /*#__PURE__*/React.createElement("a", {
        href: "/admin/polizas/".concat(polizaRenewal.poliza_id)
      }, polizaRenewal.poliza_id)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("a", {
        href: "#polizaRenewalModal",
        "data-toggle": "modal",
        "data-target": "#polizaRenewalModal",
        onClick: function onClick() {
          onSelectedPolizaRenewal && onSelectedPolizaRenewal(polizaRenewal);
        }
      }, polizaRenewal.poliza.code ? polizaRenewal.poliza.code : "Ver")), /*#__PURE__*/React.createElement("td", {
        title: polizaRenewal.aasm
      }, colorStatus(polizaRenewal.aasm_status), " ", polizaRenewal.status_name), /*#__PURE__*/React.createElement("td", null, polizaRenewal.condition_name), /*#__PURE__*/React.createElement("td", null, polizaRenewal.poliza.company ? polizaRenewal.poliza.company.name : "-"), /*#__PURE__*/React.createElement("td", null, polizaRenewal.poliza.asegurado ? "".concat(polizaRenewal.poliza.asegurado.name, " ").concat(formatRut(polizaRenewal.poliza.asegurado.rut || "")) : "-"), /*#__PURE__*/React.createElement("td", null, (_polizaRenewal$poliza = polizaRenewal.poliza) !== null && _polizaRenewal$poliza !== void 0 && _polizaRenewal$poliza.item_asegurado ? polizaRenewal.poliza.materia_asegurada_formatted : "-"), /*#__PURE__*/React.createElement("td", null, polizaRenewal.poliza.start_date ? moment(polizaRenewal.poliza.start_date).format("DD-MM-YYYY") : "-"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("b", null, polizaRenewal.poliza.finish_date ? moment(polizaRenewal.poliza.finish_date).format("DD-MM-YYYY") : "-")), /*#__PURE__*/React.createElement("td", null, (_polizaRenewal$poliza2 = polizaRenewal.poliza) !== null && _polizaRenewal$poliza2 !== void 0 && _polizaRenewal$poliza2.ramo ? polizaRenewal.poliza.ramo : "-"), /*#__PURE__*/React.createElement("td", null, (_polizaRenewal$poliza3 = polizaRenewal.poliza) === null || _polizaRenewal$poliza3 === void 0 ? void 0 : _polizaRenewal$poliza3.currency, " ", (_polizaRenewal$poliza4 = polizaRenewal.poliza) !== null && _polizaRenewal$poliza4 !== void 0 && (_polizaRenewal$poliza5 = _polizaRenewal$poliza4.commission) !== null && _polizaRenewal$poliza5 !== void 0 && _polizaRenewal$poliza5.net_bonus ? (_polizaRenewal$poliza6 = polizaRenewal.poliza) === null || _polizaRenewal$poliza6 === void 0 ? void 0 : (_polizaRenewal$poliza7 = _polizaRenewal$poliza6.commission) === null || _polizaRenewal$poliza7 === void 0 ? void 0 : _polizaRenewal$poliza7.net_bonus : "-"), /*#__PURE__*/React.createElement("td", null, (_polizaRenewal$poliza8 = polizaRenewal.poliza) === null || _polizaRenewal$poliza8 === void 0 ? void 0 : _polizaRenewal$poliza8.currency, " ", polizaRenewal.net_bonus ? polizaRenewal.net_bonus : "-"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("a", {
        href: "/admin/poliza_renewals/".concat(polizaRenewal.id, "/edit"),
        className: "btn btn-default btn-mini"
      }, /*#__PURE__*/React.createElement(FaPen, null))));
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, !polizaRenewals || polizaRenewals.length <= 0 ? /*#__PURE__*/React.createElement("h3", null, "No se han encontrado p\xF3lizas a renovar.") : /*#__PURE__*/React.createElement("table", {
    className: "table table-striped table-sm table-bordered cntListPoliza col-md-10",
    "data-toggle": "table"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "tableHeader"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "col"
  }, "Propuesta"), /*#__PURE__*/React.createElement("th", {
    scope: "col"
  }, "N\xBA P\xF3liza"), /*#__PURE__*/React.createElement("th", {
    scope: "col"
  }, "Estado"), /*#__PURE__*/React.createElement("th", {
    scope: "col"
  }, "Condici\xF3n"), /*#__PURE__*/React.createElement("th", {
    scope: "col"
  }, "Compa\xF1\xEDa"), /*#__PURE__*/React.createElement("th", {
    scope: "col"
  }, "Asegurado"), /*#__PURE__*/React.createElement("th", {
    scope: "col"
  }, "Materia"), /*#__PURE__*/React.createElement("th", {
    scope: "col"
  }, "Inicio Vigencia"), /*#__PURE__*/React.createElement("th", {
    scope: "col"
  }, "Fin Vigencia"), /*#__PURE__*/React.createElement("th", {
    scope: "col"
  }, "Ramo"), /*#__PURE__*/React.createElement("th", {
    scope: "col"
  }, "Prima Neta"), /*#__PURE__*/React.createElement("th", {
    scope: "col"
  }, "Prima Renovaci\xF3n"), /*#__PURE__*/React.createElement("th", {
    scope: "col"
  }, "Acciones"))), /*#__PURE__*/React.createElement("tbody", {
    className: "tableBody"
  }, listPolizaRenewals())));
};

export default ListPolizaRenewal;